
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-tooth-line',
      title: 'Full-Arch Implant Restorations (All-on-X)',
      description: 'Specialized full-arch implant solutions with chairside assistance to ensure predictable outcomes and seamless workflow integration.',
      image: 'https://i.imgur.com/t7yh6SS.jpeg'
    },
    {
      icon: 'ri-contrast-2-line',
      title: 'Full & Partial Dentures',
      description: 'Complete and partial dentures crafted using both digital and analog techniques for optimal fit and natural appearance.',
      image: 'https://i.imgur.com/wVM5LMC.jpeg'
    },
    {
      icon: 'ri-award-line',
      title: 'Crowns, Bridges & Veneers',
      description: 'Premium ceramic and metal crowns, bridges, and veneers crafted with precision for perfect fit and natural aesthetics.',
      image: 'https://public.readdy.ai/ai/img_res/ac200a9181dc483099729529a123c892.jpg'
    },
    {
      icon: 'ri-tools-line',
      title: 'Provisionals & Custom Implant Abutments/Bars',
      description: 'Custom provisional restorations and precision-engineered implant abutments and bars designed for optimal function.',
      image: 'https://readdy.ai/api/search-image?query=Custom%20implant%20abutments%20and%20bars%20with%20provisional%20restorations%20on%20sterile%20white%20background%2C%20titanium%20components%20and%20temporary%20prosthetics%20showing%20precision%20engineering%2C%20medical%20grade%20materials%20photography&width=400&height=300&seq=provisionals-abutments-1&orientation=landscape'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Night Guards & Sleep Appliances',
      description: 'Custom-fitted night guards for bruxism protection and TMJ management, and sleep appliances for various therapeutic needs.',
      image: 'https://i.imgur.com/xpKUjHI.jpeg'
    },
    {
      icon: 'ri-computer-line',
      title: 'Digital Design & Chairside Support',
      description: 'Advanced digital design services and on-site chairside support to ensure seamless workflow integration and predictable outcomes.',
      image: 'https://readdy.ai/api/search-image?query=Digital%20dental%20design%20workstation%20with%20computer%20displays%20showing%203D%20dental%20models%2C%20modern%20CAD%20software%20interface%20and%20digital%20workflow%20technology%2C%20professional%20laboratory%20environment%20with%20advanced%20equipment&width=400&height=300&seq=digital-design-1&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Comprehensive Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We specialize in full-arch implant cases and offer a complete range of restorative solutions 
            with both digital and analog capabilities to support your clinical goals.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="relative h-48">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute top-4 left-4 w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
                  <i className={`${service.icon} text-white text-xl w-6 h-6 flex items-center justify-center`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-12">
          <p className="text-lg text-gray-600 mb-6">
            Ready to experience our partnership approach to patient-specific prosthetics?
          </p>
          <button
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-blue-600 text-white px-8 py-4 text-lg rounded-lg hover:bg-blue-700 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            Get Started Today
          </button>
        </div>
      </div>
    </section>
  );
}
